import createSelector from 'web-app/util/custom-create-selector';

import GoHomeWithChildrenEntity from './index';

export const getAllChildren = createSelector(GoHomeWithChildrenEntity.selectors.entityMap, goHomeWithEntityMap => {
    return goHomeWithEntityMap.map(group => group.children);
});

export const getAllGroups = createSelector(GoHomeWithChildrenEntity.selectors.entityMap, entityMap =>
    entityMap.toList(),
);

export const getAllGroupsIds = createSelector(getAllGroups, groups => groups.map(group => group.id).toOrderedSet());

export const getChildById = createSelector(
    getAllGroups,
    (_, props) => props.goHomeWithChildId,
    (allGroups, goHomeWithChildId) => {
        let child;
        allGroups.forEach(group => {
            child = group.children.find(child => child.id === goHomeWithChildId);
            return !child;
        });

        return child;
    },
);
